import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { UserSettingsValue } from "../../../services/api/instances/useSettingsApi/types";
import type { UserInfo } from "../../../services/api/methodsTypes";
import { INITIAL_VALIDATION_DATA } from "../AuthForm/constants";
import {
  authReducerBuilder,
  getAllSettingsObjectReducerBuilder,
  updateUserSettingsReducerBuilder,
} from "./reducers";
import type { AuthState, AuthType, CredentialsType } from "./types";
import { StorageObject } from "../../../services/api/instances/storageApi/types/object_types";

const initialState: AuthState = {
  settingsObjects: [],
  settingsObject: null,
  userInfo: null,
  userSettings: null,
  isAuthenticated: false,
  validation: INITIAL_VALIDATION_DATA,
  isLoading: true,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setSettingsObjects: (
      state,
      action: PayloadAction<StorageObject<UserSettingsValue>[]>,
    ) => {
      state.settingsObjects = action.payload;
    },
    setUserSettings: (state, action: PayloadAction<UserSettingsValue>) => {
      state.userSettings = action.payload;
    },
    setUserInfo: (state, action: PayloadAction<UserInfo | null>) => {
      state.userInfo = action.payload;
    },
    setValidation: (
      state,
      action: PayloadAction<CredentialsType | { credentials: boolean }>,
    ) => {
      if ("credentials" in action.payload) {
        state.validation = {
          username: false,
          password: false,
          credentials: action.payload.credentials,
        };
      } else {
        const { username, password } = action.payload;
        state.validation = {
          username: !username,
          password: !password,
          credentials: false,
        };
      }
    },
    setIsUserInfoLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
  extraReducers: (builder) => {
    getAllSettingsObjectReducerBuilder(builder);
    authReducerBuilder(builder);
    updateUserSettingsReducerBuilder(builder);
  },
});

export const authReducers = authSlice.reducer;
export const {
  setSettingsObjects,
  setUserSettings,
  setUserInfo,
  setValidation,
  setIsUserInfoLoading,
} = authSlice.actions;
